import React, { Component } from 'react';

import { Grid } from '@material-ui/core';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '../../components/Dialog/Dialog';
import { ButtonDefault, ButtonPrimary } from '../../components/Button/Button';
import Toast from "../../components/Toast/Toast";
import Text from '../../components/Inputs/Text/Text';

import AlunoService from '../../services/Aluno';
import { errors } from '../../services/API';

import {
    isBlank,
    isBlankHelperText,
    isNameCompoundInvalid,
    isNameCompoundHelperText,
} from '../../helper/ValidationHelper';
import { nameMask } from '../../helper/MaskHelper';

export class Nome extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            dialog: {
                open: false,
                aluno: {
                    id: null,
                    nome: null,
                    nomeAntigo: null,
                },
                loading: false,
            },
            aluno: {
                nome: null,
            },
            errors: {
                nome: false,
            },
            helpers: {
                nome: null,
            },
        }
    }

    setToast = t => this.Toast = t;

    handleChange = (e) => {
        this.setState({
            dialog: {
                ...this.state.dialog,
                aluno: {
                    ...this.state.dialog.aluno,
                    [e.target.name]: nameMask(e.target.value), 
                },
            },
            errors: { ...this.state.errors, [e.target.name]: false },
            helpers: { ...this.state.helpers, [e.target.name]: null },
        });
    }

    // AÇÕES MODAL
    actions = () => {
        return (
            <>
                <ButtonPrimary 
                    onClick={this.handleSubmit}
                    startIcon={this.state.dialog.loading ? <CircularProgress size={16} /> : <CheckOutlinedIcon />}
                    disabled={this.state.dialog.loading}
                    style={{ margin: 4 }}
                    name="Salvar"
                />
                <ButtonDefault
                    onClick={this.close}
                    startIcon={<ClearOutlinedIcon />}
                    style={{ margin: 4 }}
                    name="Fechar"
                />
            </>
        )
    }

    openModal(aluno) {
        this.setState({
            dialog: {
                ...this.state.dialog,
                open: true,
                aluno: {
                    id: aluno.cdAluno,
                    nome: aluno.nmAluno,
                    nomeAntigo: aluno.nmAluno,
                },
            },
        });
    }

    // FECHAR MODAL
    close = () => {
        this.props.handleClose();
        this.setState({
            dialog: {
                open: false,
                aluno: {
                    id: null,
                    nome: null,
                    nomeAntigo: null,
                },
                loading: false,
            },
        })
    }

    isValid = () => {
        if (isBlank(this.state.dialog.aluno.nome) || isNameCompoundInvalid(this.state.dialog.aluno.nome)) {
            this.setState({
                errors: {
                    nome: isBlank(this.state.dialog.aluno.nome) || isNameCompoundInvalid(this.state.dialog.aluno.nome) ? true : false,
                },
                helpers: {
                    nome: isBlank(this.state.dialog.aluno.nome) ? isBlankHelperText() : isNameCompoundInvalid(this.state.dialog.aluno.nome) ? isNameCompoundHelperText() : null,
                },
            });
            return false;
        }
        return true;
    }

    handleSubmit = () => {
        this.setState({ dialog: { ...this.state.dialog, loading: true } });

        if (!this.isValid()) {
            this.setState({ dialog: { ...this.state.dialog, loading: false } });
            return
        }

        const aluno = new FormData();
        aluno.append('nome', this.state.dialog.aluno.nome.toUpperCase().trim().replaceAll(/\s+/g, " "));

        AlunoService.atualizarNome(this.state.dialog.aluno.id, aluno)
            .then(res => {
                this.Toast.setState({
                    message: {
                        message: "Nome Atualizado com Sucesso",
                        type: "success",
                        open: true
                    }
                });
                
                this.setState({ dialog: { ...this.state.dialog, loading: false } })
                setTimeout(() => this.close(), 1000);
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
            })
        .finally(() => this.setState({ dialog: { ...this.state.dialog, loading: false } }));
    }

    render() {
        return (
            <>
                <Toast parentRef={this.setToast} />
                <Dialog
                    openDialog={this.state.dialog.open}
                    title={`Alterar Nome - Aluno ${this.state.dialog.aluno.nomeAntigo}`}
                    closeDialog={this.close}
                    actions={this.actions()}
                    fullWidth={true}
                    maxWidth={"md"}
                >
                    <Grid container spacing={3}>
                        <Grid item lg={12}>
                            <Text
                                required
                                label="Nome do Aluno"
                                name="nome"
                                value={this.state.dialog.aluno.nome}
                                error={this.state.errors.nome}
                                onChange={this.handleChange}
                                helperText={this.state.helpers.nome}
                            />
                        </Grid>
                    </Grid>
                </Dialog>
            </>
        )
    }
}

export default Nome;